

export class RoutePathOutputByCompanyAndBranchStatus implements IRoutePathOutputByCompanyAndBranchStatus {
    /** The auto-generated id of the route path master */
    route_path_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: string;
    /** The company name with 50 character limit */
    company_name!: string;
    /** The branch name with 50 character limit */
    branch!: string;
    /** The path name with 255 character limit */
    path_name!: string;
    /** The start point with 5000 character limit */
    start_point!: string;
    /** The start point with 5000 character limit */
    end_point!: string;

    constructor(data?: IRoutePathOutputByCompanyAndBranchStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route_path_id = _data["route_path_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.path_name = _data["path_name"];
            this.start_point = _data["start_point"];
            this.end_point = _data["end_point"];
        }
    }

    static fromJS(data: any): RoutePathOutputByCompanyAndBranchStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathOutputByCompanyAndBranchStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route_path_id"] = this.route_path_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["path_name"] = this.path_name;
        data["start_point"] = this.start_point;
        data["end_point"] = this.end_point;
        return data; 
    }
}

export interface IRoutePathOutputByCompanyAndBranchStatus {
    /** The auto-generated id of the route path master */
    route_path_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id: string;
    /** The company name with 50 character limit */
    company_name: string;
    /** The branch name with 50 character limit */
    branch: string;
    /** The path name with 255 character limit */
    path_name: string;
    /** The start point with 5000 character limit */
    start_point: string;
    /** The start point with 5000 character limit */
    end_point: string;
}

